import { api } from '@/services/api';
import { PaginatedResponse } from '@/helpers/pagination.helper';

const BASE_URL = '/cms/settings';

export type Settings = {
  id: string;
  name: string;
  value: string;
};

export const getApplicationMinimumVersion = async () => {
  const response = await api.get<PaginatedResponse<Settings>>(`${BASE_URL}?id=app-min-version`, {
    skipAuthInterceptor: true,
  });

  return response.data.items[0].value;
};
